var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M38.74518,8.74171L31.25926,1.25495C30.45529,.45116,29.36495-.00027,28.22815,0H4.28593C1.92061,0,.00245,1.91638,0,4.28196v31.43164c0,2.36731,1.91887,4.2864,4.28593,4.2864h31.42815c2.36705,0,4.28593-1.91909,4.28593-4.2864V11.77464c.00027-1.13693-.45111-2.22739-1.25481-3.03145v-.00148Zm-18.74518,25.54358c-3.1558,0-5.71407-2.55856-5.71407-5.71471,0-3.15615,2.55828-5.71471,5.71407-5.71471s5.71407,2.55856,5.71407,5.71471-2.55828,5.71471-5.71407,5.71471h0ZM28.57185,7.09264v8.97878c0,.59162-.47955,1.07123-1.07111,1.07123H6.78519c-.59156,0-1.07111-.47961-1.07111-1.07123V6.78149c0-.59162,.47955-1.07123,1.07111-1.07123H27.18963c.28401,.00019,.55631,.11317,.75704,.31411l.31111,.31115c.20092,.20075,.31389,.47308,.31407,.75712Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.9c9ba25f7b4e363dfedbd2950f023a9a.svg";
export { ForwardRef as ReactComponent };